import { render } from "./PageFrame.vue?vue&type=template&id=3dd3800d&scoped=true&ts=true"
import script from "./PageFrame.vue?vue&type=script&lang=ts"
export * from "./PageFrame.vue?vue&type=script&lang=ts"

import "./PageFrame.vue?vue&type=style&index=0&id=3dd3800d&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd3800d"]])

export default __exports__